/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Cta_Lead_AgentsInputs */

const en_cmp_cta_lead_agents = /** @type {(inputs: Cmp_Cta_Lead_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep runs the agents you already use from one plan, then requires evidence before a task counts as done. The result is readable by people who don’t read diffs.`)
};

const id_cmp_cta_lead_agents = /** @type {(inputs: Cmp_Cta_Lead_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menjalankan agen yang sudah Anda pakai dari satu rencana, lalu mewajibkan bukti sebelum task dianggap selesai. Hasilnya bisa dilihat orang yang tidak membaca diff.`)
};

/**
* | output |
* | --- |
* | "Bystep runs the agents you already use from one plan, then requires evidence before a task counts as done. The result is readable by people who don’t read di..." |
*
* @param {Cmp_Cta_Lead_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_cta_lead_agents = /** @type {((inputs?: Cmp_Cta_Lead_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Cta_Lead_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_cta_lead_agents(inputs)
	return en_cmp_cta_lead_agents(inputs)
});